import $ from "cash-dom";
import "./flows/forms.js";
import "./ga.js";
import "./lazyload.js";
import "./account.js";
import "./flows/companyReportLinks.js";
import {
  disableNavbarMobileScroll,
  enableNavbarMobileScroll,
  MOBILE_BREAKPOINT,
} from "./navbar-mobile-scroll-handler.js";

$(function () {
  $("#burger-search").on("click", function () {
    $("#burger-search").addClass("is-hidden");
    $(".close-nav-button").removeClass("is-hidden");
    $("#mobile-nav").addClass("mobile-nav_enabled");
    disableNavbarMobileScroll();
  });
  $(".close-nav-button").on("click", function () {
    $("#mobile-nav").removeClass("mobile-nav_enabled");
    $(".close-nav-button").addClass("is-hidden");
    $("#burger-search").removeClass("is-hidden");
    enableNavbarMobileScroll();
  });
  $(window).on("resize", function () {
    if (
      screen.width < MOBILE_BREAKPOINT &&
      $("#mobile-nav").hasClass("mobile-nav_enabled")
    )
      disableNavbarMobileScroll();
    else enableNavbarMobileScroll();
  });

  /* Hide Header Search on scroll down. Taken from:
   ** https://codingreflections.com/hide-header-on-scroll-down/
   */

  const doc = document.documentElement;
  const w = window;

  let prevScroll = w.scrollY || doc.scrollTop;
  let curScroll;
  let direction = 0;
  let prevDirection = 0;

  const header = $("#header .company-search").get(0);

  const checkScroll = function () {
    /*
     ** Find the direction of scroll
     ** 0 - initial, 1 - up, 2 - down
     */

    curScroll = w.scrollY || doc.scrollTop;
    if (curScroll > prevScroll) {
      //scrolled up
      direction = 2;
    } else if (curScroll < prevScroll) {
      //scrolled down
      direction = 1;
    }

    if (direction !== prevDirection) {
      toggleHeader(direction, curScroll);
    }

    prevScroll = curScroll;
  };

  const toggleHeader = function (direction, curScroll) {
    if (direction === 2 && curScroll > 200) {
      header.classList.add("hide");
      prevDirection = direction;
    } else if (direction === 1 && curScroll <= 200) {
      header.classList.remove("hide");
      prevDirection = direction;
    }
  };

  window.addEventListener("scroll", checkScroll);

  $("[data-acsb='trigger']").on("click", () => {
    const loaded = sessionStorage.getItem("acsb_loaded");
    if (loaded) {
      return;
    }
    sessionStorage.setItem("acsb_loaded", true);
    window.location.href = window.location.href + "#showacsb";
    document.location.reload();
  });
});
